var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var RADIUS_COEFFICIENT = 0.2;
var COLOR_BASE_VALUE = 0xffffff;
var COLOR_COEFFICIENT = 0x00f055;
var Point = /** @class */ (function (_super) {
    __extends(Point, _super);
    function Point(scene, data) {
        var _this = _super.call(this, scene, data.x, data.y) || this;
        _this.data_vector = data;
        var exp = _this.data_vector.exp;
        var radius = exp * RADIUS_COEFFICIENT;
        var color = COLOR_BASE_VALUE - exp * COLOR_COEFFICIENT;
        _this.arc = new Phaser.GameObjects.Arc(scene, 0, 0, radius, 0, 360, false, color, 1);
        _this.setSize(radius * 2, radius * 2);
        _this.add(_this.arc);
        return _this;
    }
    Point.prototype.setExp = function (exp) {
        var radius = exp * RADIUS_COEFFICIENT;
        var color = COLOR_BASE_VALUE - exp * COLOR_COEFFICIENT;
        this.arc.radius = radius;
        this.arc.fillColor = color;
    };
    Point.prototype.setValue = function (data) {
        if (this.data_vector.id !== data.id)
            return;
        this.data_vector = data;
        var _a = this.data_vector, exp = _a.exp, x = _a.x, y = _a.y;
        this.setExp(exp);
        this.setPosition(x, y);
        var radius = exp * RADIUS_COEFFICIENT;
        var color = COLOR_BASE_VALUE - exp * COLOR_COEFFICIENT;
        this.arc.radius = radius;
        this.arc.fillColor = color;
    };
    Point.prototype.getValue = function () {
        return this.data_vector;
    };
    return Point;
}(Phaser.GameObjects.Container));
export default Point;
